import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconTypeBoolean = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M13.2803 4.28033C13.5732 3.98744 13.5732 3.51256 13.2803 3.21967C12.9874 2.92678 12.5126 2.92678 12.2197 3.21967L6.75 8.68934L4.28033 6.21967C3.98744 5.92678 3.51256 5.92678 3.21967 6.21967C2.92678 6.51256 2.92678 6.98744 3.21967 7.28033L6.21967 10.2803C6.25628 10.3169 6.29574 10.349 6.33732 10.3764C6.62844 10.5686 7.02405 10.5366 7.28033 10.2803L13.2803 4.28033Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.0597 20.7771C13.7668 20.4843 13.7668 20.0094 14.0597 19.7165L16.3578 17.4184L14.0597 15.1203C13.7668 14.8274 13.7668 14.3525 14.0597 14.0596C14.3526 13.7667 14.8275 13.7667 15.1204 14.0596L17.4185 16.3577L19.7166 14.0596C20.0094 13.7667 20.4843 13.7667 20.7772 14.0596C21.0701 14.3525 21.0701 14.8274 20.7772 15.1203L18.4791 17.4184L20.7772 19.7165C21.0701 20.0094 21.0701 20.4843 20.7772 20.7771C20.4843 21.07 20.0094 21.07 19.7166 20.7771L17.4185 18.4791L15.1204 20.7771C14.8275 21.07 14.3526 21.07 14.0597 20.7771Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.5303 6.53033C18.8232 6.23744 18.8232 5.76256 18.5303 5.46967C18.2374 5.17678 17.7626 5.17678 17.4697 5.46967L5.46967 17.4697C5.17678 17.7626 5.17678 18.2374 5.46967 18.5303C5.76256 18.8232 6.23744 18.8232 6.53033 18.5303L18.5303 6.53033Z",
			fill: "currentColor"
		})
	]
});
export { SvgIconTypeBoolean as ReactComponent };
